import useAuthority from "../../hooks/useAuthority";
import { AUTH_TYPES, AUTHORITY_TYPE } from "../../const";

const Spinner = ({ size = 15 }) => (
  <>
    <span
      aria-hidden="true"
      style={{
        width: size,
        height: size,
        borderRadius: "50%",
        border: "2px solid currentColor",
        borderRightColor: "transparent",
        display: "inline-block",
        animation: "btnSpin 0.8s linear infinite",
      }}
    />
    <style>{`
      @keyframes btnSpin { 
        to { transform: rotate(360deg); } 
      }
    `}</style>
  </>
);

const ButtonRenderer = ({
  clickHandler,
  label,
  isLoading = false,
  iconColor = "",
  filled = false,
  iconSize = 15,
  type = "button",
  className = "ui primary button",
  disabled = false,
  Icon = null,
  editMode = false,
  authType = AUTHORITY_TYPE.FORM,
  needDeletePermission = false,
  form = "-",
  field = "-",
  module = "-",
  authenticated = false,
  consider = AUTH_TYPES.VIEW,
  style = null,
  ...props
}) => {
  const { view, authorized, deletePermission } = useAuthority({
    type: authType,
    module: module,
    field: field,
    form: form,
    editMode: editMode,
    authenticated: authenticated,
    needDeletePermission,
  });

  return (
    <>
      <button
        {...props}
        style={style ?? {}}
        className={className}
        type="button"
        onClick={clickHandler}
        disabled={
          disabled ||
          (consider === AUTH_TYPES.VIEW
            ? !view
            : consider === AUTH_TYPES.DELETE
              ? editMode
                ? !deletePermission
                : !authorized
              : !authorized)
        }
      >
        {isLoading ? (
          <Spinner size={15} />
        ) : Icon ? (
          <div style={{ display: "flex", alignItems: "center" }}>
            {label && <span>{label}</span>}
            <div style={{ display: "flex", alignItems: "center" }}>
              <Icon size={iconSize} style={label ? { marginLeft: "5px" } : {}} color= {iconColor} fill={filled ? iconColor : ""}/>
            </div>
          </div>
        ) : (
          <>{label}</>
        )}
      </button>
    </>
  );
};

export default ButtonRenderer;
